<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="secondary">
        <span v-if="$route.params.id">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/arac/listesi">{{ $t('menu.vehicles') }}</router-link> / {{ item.name_readable }}
        </span>
        <span v-else>
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/arac/listesi">{{ $t('menu.vehicles') }}</router-link> / {{ $t('tables.actions.create') }}
        </span>
      </div>
      <div class="va-card__header-actions"/>
    </template>
    <form @submit.prevent="onsubmit">
      <div class="row">
        <!-- VEHICLE GENERAL -->
        <div class="flex xs12">
          <div class="text-block">
            <p class="display-5">GENEL BİLGİ</p>
            <div class="row">
              <div class="flex xs12">
                <fieldset>
                    <va-checkbox
                      label="Araç listede görünsün mü?"
                      v-model="form.is_active"
                    />
                </fieldset>
              </div>
              <div class="flex md12x sm12 xs12">
                <va-input
                  v-model="form.name"
                  label="İsim"
                  placeholder="Araç ismi girin"
                  required
                />
              </div>
              <div class="flex md6 sm6 xs12">
                <va-select
                  v-model="item.size"
                  keyBy="key"
                  textBy="value"
                  :options="sizes"
                  label="Büyüklük"
                  placeholder="Araç büyüklüğü seçin"
                />
              </div>
              <div class="flex md6 sm6 xs12">
                <va-select
                  v-model="item.segment"
                  textBy="name_readable"
                  keyBy="id"
                  :options="segments"
                  label="Segment"
                  placeholder="Araç segmenti seçin"
                />
              </div>
              <div class="flex xs12">
                <va-input
                  type="number"
                  step="any"
                  v-model="form.daily_free_km"
                  label="Ücretsiz km Hakkı"
                  placeholder="Günlük ücretsiz km hakkı girin"
                  required
                >
                  <va-icon
                    slot="append"
                    color="gray"
                  >km</va-icon>
                </va-input>
              </div>
            </div>
          </div>
        </div>
        <!-- VEHICLE IMAGES -->
        <div class="flex xs12">
          <div class="text-block">
            <p class="display-5">FOTOĞRAFLAR</p>
            <div class="row">
              <div class="flex md6 xs12">
                <div class="row">
                  <div class="flex md6 xs12 text--center"
                    v-for="(img, index) in form.images_readable"
                    :key="img"
                  >
                    <img :src="img" style="width:100%;height:auto;max-width:450px;max-height:200px"/>
                    <va-popover message="Resmi Sil" placement="bottom" :disabled="isMobile">
                      <va-button type="button" small color="danger" icon="fa fa-close" @click.stop="deleteImage(index)">Sil</va-button>
                    </va-popover>
                  </div>
                </div>
                <div class="row">
                  <div class="flex xs12 text--center">
                    <input
                      type="file"
                      name="image"
                      accept="image/*"
                      style="display:none"
                      ref="vehicleInputFile"
                      @change="setImage"
                    >
                    <va-button type="button" small color="warning" @click.stop="handleFileInput">Yeni Fotoğraf Ekle</va-button>
                  </div>
                </div>
              </div>
              <div class="flex md6 xs12">
                <div class="row">
                  <div class="flex xs12 text--center"
                    v-for="(img, index) in images"
                    :key="img.url"
                  >
                    <vue-cropper
                      :ref="'cropper'+index"
                      :src="img.url"
                      :rotatable="true"
                      :view-mode="2"
                      :aspectRatio="9/4"
                      drag-mode="crop"
                      v-model="croppaImages[index]"
                      :img-style="{'width': '100%', 'height': '100%', 'max-width': '900px', 'max-height': '400px'}"
                      :width="900"
                      :height="400"
                      :accept="'image/*'"
                      :file-size-limit="1500000"
                    />
                    <va-popover message="Resmi Döndür" placement="bottom" :disabled="isMobile">
                      <va-button type="button" small color="info" icon="fa fa-rotate-left" @click.stop="rotateCroppaImage(img)">Döndür</va-button>
                    </va-popover>
                    <va-popover message="Resmi Sil" placement="bottom" :disabled="isMobile">
                      <va-button type="button" small color="danger" icon="fa fa-close" @click.stop="deleteCroppaImage(img, index)">Sil</va-button>
                    </va-popover>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- VEHICLE PRICES -->
        <div class="flex md6 sm6 xs12">
          <div class="text-block">
            <p class="display-5">GÜNLÜK KİRALAMA FİYATLARI</p>
            <div class="row">
              <div class="flex xs12">
                <va-input
                  type="number"
                  step="any"
                  v-model="form.prices['1+']"
                  label="1-4 Gün Fiyatı"
                  placeholder="1-4 gün için günlük kiralama fiyatını girin"
                  required
                >
                  <va-icon
                    slot="append"
                    color="gray"
                    name=""
                  >₺/gün</va-icon>
                </va-input>
              </div>
              <div class="flex xs12">
                <va-input
                  type="number"
                  step="any"
                  v-model="form.prices['5+']"
                  label="5-7 Gün Fiyatı"
                  placeholder="5-7 gün için günlük kiralama fiyatını girin"
                  required
                >
                  <va-icon
                    slot="append"
                    color="gray"
                  >₺/gün</va-icon>
                </va-input>
              </div>
              <div class="flex xs12">
                <va-input
                  type="number"
                  step="any"
                  v-model="form.prices['8+']"
                  label="8-15 Gün Fiyatı"
                  placeholder="8-15 gün için günlük kiralama fiyatını girin"
                  required
                >
                  <va-icon
                    slot="append"
                    color="gray"
                    name=""
                  >₺/gün</va-icon>
                </va-input>
              </div>
              <div class="flex xs12">
                <va-input
                  type="number"
                  step="any"
                  v-model="form.prices['16+']"
                  label="16+ Gün Fiyatı"
                  placeholder="15 günden fazla süre için günlük kiralama fiyatını girin"
                  required
                >
                  <va-icon
                    slot="append"
                    color="gray"
                    name=""
                  >₺/gün</va-icon>
                </va-input>
              </div>
            </div>
          </div>
        </div>
        <!-- VEHICLE PROPERTIES -->
        <div class="flex md6 sm6 xs12">
          <div class="text-block">
            <p class="display-5">ÖZELLİKLER</u>
            <div class="row">
              <div class="flex md6 xs12">
                <fieldset>
                  <p class="title" color="primary">Vites Türü</p>
                  <va-radio-button
                    option="automatic"
                    v-model="form.properties['transmission']"
                    label="Otomatik Vites"
                  />
                  <va-radio-button
                    option="manuel"
                    v-model="form.properties['transmission']"
                    label="Manuel Vites"
                  />
                </fieldset>
              </div>
              <div class="flex md6 xs12">
                <fieldset>
                  <p class="title">Yakıt Türü</p>
                  <va-radio-button
                    option="diesel"
                    v-model="form.properties['fuel_type']"
                    label="Diesel"
                  />
                  <va-radio-button
                    option="gas"
                    v-model="form.properties['fuel_type']"
                    label="Benzin"
                  />
                </fieldset>
              </div>
              <div class="flex md6 xs12">
                <va-input
                  type="number"
                  v-model="form.properties['seat_count']"
                  label="Koltuk Sayısı"
                  placeholder="Koltuk sayısı girin"
                  required
                />
              </div>
              <div class="flex md6 xs12">
                <va-input
                  type="number"
                  v-model="form.properties['door_count']"
                  label="Kapı Sayısı"
                  placeholder="Kapı sayısı girin"
                  required
                />
              </div>
              <div class="flex xs12">
                <va-select
                  v-model="item.properties.luggage_size"
                  keyBy="key"
                  textBy="value"
                  :options="luggageSizes"
                  label="Bagaj Büyüklüğü"
                  placeholder="Bagaj büyüklüğü seçin"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import vehicleServices from '../../services/api/vehicle'
import vehicleSegmentServices from '../../services/api/vehicleSegment'
import uploadServices from '../../services/api/upload'
import responseMixin from '../../services/api/response'
import helperMixin from '../../services/helper'
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
export default {
  mixins: [responseMixin, helperMixin],
  components: { VueCropper },
  data () {
    return {
      isMobile: false,
      item: {
        segment: {
          id: null,
          name_readable: ''
        },
        size: {
          id: null,
          text: ''
        },
        properties: {
          fuel_type: 'diesel',
          door_count: null,
          seat_count: null,
          transmission: 'automatic',
          luggage_size: {
            key: null,
            value: ''
          }
        },
      },
      form: {
        name: '',
        language: 'tr',
        type: 'car',
        images: [],
        new_images: [],
        images_readable: [],
        size: null,
        prices: {
          '1+' : null,
          '5+' : null,
          '8+' : null,
          '16+': null
        },
        vehicle_segment_id: null,
        daily_free_km: null,
        properties: {
          fuel_type: 'diesel',
          door_count: null,
          seat_count: null,
          transmission: 'automatic',
          luggage_size: null
        },
        is_active: true
      },
      segments: [],
      sizes: [
        {'key': '1-2person', 'value': '1-2 Kişi'},
        {'key': 'small-group', 'value': 'Küçük Grup'},
        {'key': 'big-group', 'value': 'Büyük Grup'}
      ],
      luggageSizes: [
        { 'key': '1-2', 'value': '1-2 Valiz'},
        { 'key': '4', 'value': '4 Valiz'}
      ],
      croppaImages: [],
      images: [],
      imagesReady: false
    }
  },
  watch: {
    'item.size': function(selected) {
      this.form.size = selected ? selected.key : null;
    },
    'item.segment': function(selected) {
      this.form.vehicle_segment_id = selected ? selected.id : null;
    },
    'item.properties.luggage_size': function(selected) {
      this.form.properties.luggage_size = selected ? selected.key : null;
    },
    '$route': function(val) {
      this.item = {
        segment: {id: null, name_readable: ''},
        size: {id: null, text: ''},
        properties: {fuel_type: 'diesel', door_count: null,seat_count: null, transmission: 'automatic', luggage_size: {key: null, value: ''}}
      };
      this.form = {
        name: '', language: 'tr', type: 'car',images: [], images_readable: [], size: null,
        prices: {'1+' : null, '5+' : null, '8+' : null, '16+': null},
        vehicle_segment_id: null, daily_free_km: null,
        properties: {fuel_type: 'diesel', door_count: null, seat_count: null, transmission: 'automatic', luggage_size: null},
        is_active: true,
      };
      this.croppaImages = [];
      this.images = [];
      this.imagesReady = false;
      if(val.params.id) {
        this.getVehicle(val.params.id);
      }
    },
    'imagesReady': function(val) {
      if(val) {
        if(this.$route.params.id) {
          this.putVehicle(this.$route.params.id);
        }
        else {
          this.postVehicle();
        }
      }
    },
    'images': function(val) {
      this.images = val;
    }
  },
  methods: {
    async getVehicle(id) {
      const result = await vehicleServices.get(id, {
        params: {
          'include': 'segment'
        }
      });
      if(result.error){
        return ;
      }
      this.item = result.data.data;
      this.form.name = this.item.name.tr;
      this.formatForm();
    },
    formatForm() {
      this.form.daily_free_km = this.item.daily_free_km;
      this.form.vehicle_segment_id = this.item.vehicle_segment_id;
      this.form.is_active = this.item.is_active;
      this.form.images = this.item.images;
      this.form.images_readable = this.item.images_readable ? this.item.images_readable : [];
      this.formatSize();
      this.formatPrices();      
      this.formatProperties();
    },
    formatSize() {
      if(!!this.item.size){
        this.item.size = this.sizes.find(obj => obj.key === this.item.size);
      }
      else {
        this.item.size = { key: null, value: '' };
      }
      this.form.size = this.item.size.key;
    },
    formatPrices() {
      if(!(this.$route.params.id && !!this.item.prices)) {
        this.item.prices = {
          '1+' : null,
          '5+' : null,
          '8+' : null,
          '16+': null
        };
      }
      this.form.prices = Object.assign({}, this.item.prices);
    },
    formatProperties() {
      if(!(this.$route.params.id && !!this.item.properties)) {
        this.item.properties = {
          fuel_type: 'diesel',
          door_count: null,
          seat_count: null,
          transmission: 'automatic',
          luggage_size: null
        };
      }
      this.form.properties = Object.assign({}, this.item.properties);
      this.formatPropertyLuggageSize();
    },
    formatPropertyLuggageSize() {
      if(!!this.item.properties && !!this.item.properties.luggage_size){
        this.item.properties.luggage_size = this.luggageSizes.find(obj => obj.key === this.item.properties.luggage_size);
      }
      else {
        this.item.properties.luggage_size = { key: null, value: '' };
      }
      this.form.properties.luggage_size = this.item.properties.luggage_size.key;
    },
    async getVehicleSegments(){
      const result = await vehicleSegmentServices.get();
      if(result.error){
        return ;
      }
      this.segments = result.data.data;
    },
    async uploadImage(image, index) {
      let uploadData = {
        path: 'vehicles', 
        file: image
      };
      uploadData = window.jsonToFormData(uploadData);
      const res = await uploadServices.post({
        data: uploadData,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      if(res.error){
        //error handling
        this.responseToast('POST', 'error', res, 'fa-upload', 'Fotoğraf yükleme');
        return ;
      }
      this.responseToast('POST', 'success', res, 'fa-upload', 'Fotoğraf yükleme');
      this.form.images_readable.push(res.data.data.cdn_url);
      this.form.images.push(res.data.data.path);
      if(this.images.length == index + 1) {
        this.imagesReady = true;
      }
    },
    async postVehicle() {
      const res = await vehicleServices.post({
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('POST', 'error', res);
        this.imagesReady = false;
        return ;
      }
      this.responseToast('POST', 'success');
      this.putVehicleEN(res.data.data.id);
    },
    async putVehicle(id) {
      const res = await vehicleServices.put(id, {
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('PUT', 'error', res);
        this.imagesReady = false;
        return ;
      }
      this.responseToast('PUT', 'success');
      this.putVehicleEN(res.data.data.id);
    },
    async putVehicleEN(id) {
      this.form.language = 'en';
      const res = await vehicleServices.put(id, {
        data: this.form
      });
      if(res.error){
        //error handling
        this.imagesReady = false;
        return ;
      }
      this.redirectTo('/arac/'+id, 2500);
    },
    async onsubmit () {
      //validation
      if(!!this.images && this.images.length>0) {
        await this.resolveImages(s => {});
      }
      else {
        this.imagesReady = true;
      }
    },
    handleFileInput() {
      this.$refs.vehicleInputFile.click();
    },
    setImage(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Lütfen resim dosyası seçiniz.");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          var image = {};
          image.url = URL.createObjectURL(file);
          image.name = file.name;
          this.images.push(image);
        };
        reader.readAsDataURL(file);
      }
    },
    rotateCroppaImage(image) {
      let index = this.images.findIndex(i => i == image);
      this.croppaImages[index] = this.$refs["cropper" + index][0].rotate(90);
    },
    deleteImage(index) {
      this.form.images_readable.splice(index, 1);
      this.form.images.splice(index, 1);
    },
    deleteCroppaImage(image, index) {
      this.images.splice(index, 1);
      delete this.croppaImages[index];
    },
    asyncForEach: async function(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    async resolveImages(callback) {
      let file = null;
      this.asyncForEach(this.images, async (image, index) => 
        {
          if (image) {
            await this.$refs["cropper" + index][0]
              .getCroppedCanvas()
              .toBlob(blob => {
                file = new File([blob], "file_name" + index, { lastModified: 1534584790000 });
                this.uploadImage(file, index);
                if (this.images.length == index + 1) {
                  callback();
                }
              });
          }
        });    
    },
  },
  created () {
    this.isMobile = this.checkIsMobile();
    this.getVehicleSegments();
    if(this.$route.params.id) {
      this.getVehicle(this.$route.params.id);
    }
  },
}
</script>